export type TSteps = Array<{
  id: number
  label: string
  subLabel?: string
  number: number | false
  hasNavigation: boolean
  bg?: 'dark' | 'middle' | 'light' | 'last'
}>

export const stepsData: TSteps = [
  {
    id: 0,
    label: "Now you'll learn how to properly conduct the evaluation game",
    subLabel: 'Follow the instructions carefully',
    number: false,
    hasNavigation: false
  },
  {
    id: 1,
    label: 'set up',
    number: 1,
    hasNavigation: false
  },
  {
    id: 2,
    label: "isn't hungry or tired",
    subLabel: 'Make sure your child',
    number: false,
    hasNavigation: true,
    bg: 'dark'
  },
  {
    id: 3,
    label: 'Choose a quiet environment',
    number: false,
    hasNavigation: true,
    bg: 'middle'
  },
  {
    id: 4,
    label: 'and check that your child is comfortable holding the device',
    number: false,
    hasNavigation: true,
    bg: 'light'
  },
  {
    id: 5,
    label: 'tutorials',
    number: 2,
    hasNavigation: false
  },
  {
    id: 6,
    label: 'tutorial explaining how to play',
    subLabel: 'every game starts with a',
    number: false,
    hasNavigation: true,
    bg: 'dark'
  },
  {
    id: 7,
    label: 'Go over tutorials together with your child',
    number: false,
    hasNavigation: true,
    bg: 'middle'
  },
  {
    id: 8,
    label: 'and make sure they understand how to play before starting the game',
    number: false,
    hasNavigation: true,
    bg: 'light'
  },
  {
    id: 9,
    label: 'evaluation phase',
    number: 3,
    hasNavigation: false
  },
  {
    id: 10,
    label: 'the real evaluation begins',
    subLabel: 'at the end of every tutorial',
    number: false,
    hasNavigation: true,
    bg: 'dark'
  },
  {
    id: 11,
    label: 'allow your child to play the game on his or her own',
    subLabel: 'you should step aside and',
    number: false,
    hasNavigation: true,
    bg: 'middle'
  },
  {
    id: 12,
    label: "Seriously, don't interfere with your child's session",
    number: false,
    hasNavigation: true,
    bg: 'last'
  }
]



// WEBPACK FOOTER //
// ./src/data/parentalInstructions/index.ts